import { get_token } from "@/router";
export default {
  name: 'AddTaskCard',
  props: {
     column_id: {
      type: Number,
      required: true
    }
    },
  data() {
    return ({
      task_name: '',
      selectedDate: '',
      members: [],
      assignedMembers: [],
      searchQuery: '',
      errors: {},

    });
  },
    computed: {
    filteredMembers() {
    return this.members.filter(m =>
      !this.assignedMembers.some(a => a.id === m.id) &&
      m.full_name.toLowerCase().includes(this.searchQuery.toLowerCase())
    )
  }
    },
  methods: {
    getToken() {
            return get_token();
            },
    resizeTaskNameInput() {
      const input = this.$refs.taskNameInput;
      if (!input) return;

      input.style.height = 'auto';
      input.style.height = `${input.scrollHeight}px`;
    },
    add_task(){
      if (this.validateTaskForm()) {
     const assigned_ids = this.assignedMembers.map(u => u.id);
     const formattedDate = this.selectedDate
      ? new Date(this.selectedDate).toISOString().split('T')[0]  // "YYYY-MM-DD"
      : null;
      const baseUrl = `${window.location.origin}${this.$route.path}`;
      const encodedReportUrl = encodeURI(`${baseUrl}?task_id=dynamic_placeholder`);


      $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_task/`,
                method: 'POST',
                headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
                },
                data: JSON.stringify({
                  column_id: this.column_id,
                  name:this.task_name,
                  assigned_ids:assigned_ids,
                  due_date:formattedDate,
                  base_url: encodedReportUrl
                }),
                success: (response) => {
                var status = response.status
                if (status == "success") {
                    this.$emit("add-task", response.data);
                }

                },
                error: (xhr) => {
                this.errors = xhr.responseJSON?.errors || {};
              },

                complete: () => {
                this.isLoading = false;
                }
            });
            }
    },
    triggerDatePicker() {
      const input = this.$refs.dateInput;
      if (!input) return;

      if (typeof input.showPicker === 'function') {
        input.showPicker();
        return;
      }

      input.focus();
      input.click();
    },
    handleDateChange(event) {
      this.selectedDate = event.target.value;
    },
    formatDate(date) {
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return new Date(date).toLocaleDateString(undefined, options);
    },
 fetchPortalMembers() {
    if (this.isFetchingPortalMembers || this.hasFetchedPortalMembers) {
      return;
    }

    this.isFetchingPortalMembers = true;
    this.members = [];

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_members/`,
      method: "GET",
      data: { portal_id:this.$route.params.portal_id },
      headers: {
        "Authorization": `Token ${this.getToken()}`,
        "Content-Type": "application/json"
      },
      success: (response) => {
        if (response.status === "success") {
          this.members = response.data.members;
          this.hasFetchedPortalMembers = true;
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        }
      },
      error: (xhr) => {
        console.error("Error fetching portal members:", xhr);
      },
      complete: () => {
        this.isFetchingPortalMembers = false;
        this.isLoading = false;
      }
    });
  },
  getInitials(name) {
  if (!name || typeof name !== 'string') return '??'; // fallback
  const parts = name.trim().split(' ');
  return parts.map(p => p[0]).join('').toUpperCase().substring(0, 2);
},
   assignUser(member) {
    if (!this.assignedMembers.find(a => a.id === member.id)) {
      this.assignedMembers.push(member);
    }
  },
    removeAssignedUser(member) {
        this.assignedMembers = this.assignedMembers.filter(a => a.id !== member.id);
    },
     validateTaskForm() {
      this.errors = {};
      let isValid = true;
      if (!this.task_name.trim()) {
        this.errors.task_name = 'Task name is required.';
        isValid = false;
      }
      return isValid;
    },
  },
};
